import { ValueType } from 'realgrid'

export const uploadFields = [
    { fieldName: 'itemCd', dataType: ValueType.TEXT },
    { fieldName: 'qty', dataType: ValueType.NUMBER },
    { fieldName: 'validYn', dataType: ValueType.TEXT },
    { fieldName: 'validMsg', dataType: ValueType.TEXT }
  ]
  export const uploadColumns = [
    {
      name: 'itemCd',
      fieldName: 'itemCd',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: {
        text: '제품코드',
        showTooltip: false
      },
      visible: true,
      editable: true
    },
    {
      name: 'qty',
      fieldName: 'qty',
      type: 'data',
      width: '50',
      numberFormat: "#,##0.#",
      styleName: "rg-align-right",
      header: {
          text: '주문수량',
          showTooltip: false
      },
      visible: true,
      editable: true
  },
  {
    name: 'validYn',
    fieldName: 'validYn',
    type: 'data',
    width: '50',
    styleName: "rg-align-center",
    header: {
      text: '검증여부',
      showTooltip: false
    },
    visible: true,
    editable: false
  },
  {
    name: 'validMsg',
    fieldName: 'validMsg',
    type: 'data',
    width: '100',
    styleName: "rg-align-center",
    header: {
      text: '참조',
      showTooltip: false
    },
    visible: true,
    editable: false
  }
  ]